import { NonprofitEntityType } from 'entities/organization/model';
import { Privileges } from 'utils/privileges';
import { UserState } from 'entities/user/reducer';
import { OnboardingStep } from 'entities/user/model';

export const dataCaptureStepNames = ['presence' as const, 'contact' as const, 'brand' as const];

export type DataCaptureStepType = (typeof dataCaptureStepNames)[number];

/**
 * This function calculates an ordered array of all allowed steps in onboarding
 * Please don't duplicate this logic and rather derive needed data from here
 */
export const getAllowedSteps = (user: UserState): OnboardingStep[] => {
  const isPayPalUnenrolled =
    user?.organization?.payPalModel &&
    !['PPGF_ENROLLED', 'DIRECT_MODEL_ENROLLED'].includes(user?.organization?.paypalCharityType);

  const dataCaptureSteps: Partial<Record<DataCaptureStepType, boolean>> =
    !user?.organization?.nonprofitDataValidatedAt &&
    user?.hasPrivilege(Privileges.ORGANIZATION_MANAGE_SETTINGS)
      ? {
          presence: true,
          contact: true,
          brand: true,
        }
      : {};
  const stepsMap = {
    verification: user?.hasPrivilege(Privileges.ORGANIZATION_SELF_VERIFY_OWNERSHIP),
    // @NOTE-DP: if it's PP but not enrolled, it means the user has already seen the payment
    payment:
      !isPayPalUnenrolled &&
      user?.organization?.nonprofitEntityType !== NonprofitEntityType.governmentEntity &&
      user?.organization?.nonprofitEntityType !== NonprofitEntityType.memberAssociatedEntity,
    companyAffiliation: user?.hasPrivilege(Privileges.PARTNER_MANAGE),
    ...dataCaptureSteps,
    needHelp: true,
  };

  return (Object.keys(stepsMap) as OnboardingStep[]).filter((stepName) => stepsMap[stepName]);
};
